import * as React from 'react';
import {Component} from 'react';
import {RadioButton} from '@priority-software/priority-style-react';
import keyCodes from '../../../../constants/KeyCodes';

export class BoolControl extends Component<any, any> {
    state = {
        currentFocusValue: undefined
    };
    onFocus = e => {
        this.props.setActive();
        this.setState({currentFocusValue: e.target.value});
        window.addEventListener('keydown', this.handleKeyDown, true);
    };

    componentDidMount() {
        this.props.setActive();
    }

    onBlur = () => {
        this.props.unsetActive();
        window.removeEventListener('keydown', this.handleKeyDown, true);
    };

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
    }

    handleKeyDown = e => {
        e.stopPropagation();
        switch (e.keyCode) {
            case keyCodes.ENTER:
                this.state.currentFocusValue && this.props.onChange(this.state.currentFocusValue);
                break;
            default:
                break;
        }
    };

    render() {
        const {selected, onChange, options, autoFocus} = this.props;
        return (
            <RadioButton
                selected={selected}
                onChange={onChange}
                options={options}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                autoFocus={autoFocus}
            />
        );
    }
}
